import { createAction, createRequestTypes, FAILURE, REQUEST, SUCCESS } from 'utils/actionGenerator';

export const GET_SEARCH_RESULTS = createRequestTypes('src/places/GET_SEARCH_RESULTS');
export const SELECT_PLACE = createRequestTypes('src/places/SELECT_PLACE');
export const EMPTY_SEARCHES = createRequestTypes('src/places/EMPTY_SEARCHES');

export const getSearchResults = {
  request: (params) => createAction(GET_SEARCH_RESULTS[REQUEST], { params }),
  success: (response) => createAction(GET_SEARCH_RESULTS[SUCCESS], { response }),
  failure: (response) => createAction(GET_SEARCH_RESULTS[FAILURE], { response }),
};

export const selectPlace = {
  request: (payload) => createAction(SELECT_PLACE[REQUEST], { payload }),
  success: (response) => createAction(SELECT_PLACE[SUCCESS], { response }),
  failure: (response) => createAction(SELECT_PLACE[FAILURE], { response }),
};

export const emptySearches = () => ({
  type: EMPTY_SEARCHES,
});
